module.exports = __webpack_public_path__ + "static/img/img_main.8ffe88e8.png";